import React, { Component } from 'react';
import { connect } from 'react-redux';

import Spinner from '../../../components/UI/Spinner/Spinner';
import classes from './Confirm.css';
import axios from '../../../axios-local-api';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler'
import * as actions from '../../../store/actions/index';
class Confirm extends Component {
  state = {
    formIsValid: false
  }

  render() {
    //console.log('connfirmation modal props :', this.props);
    let form = (
      <div className={`${this.props.deviceGroupConfirmation ? classes.DeviceGroupButtonRow : this.props.firmwareUpdateConfirm ? classes.firmwareUpdateBtnRow : classes.ButtonRow} ${this.props.footerStyle}`}>
        <button
          id={this.props.id ? this.props.id : this.props.cancelId ? this.props.cancelId : 'ModalCancelButton'}
          className={this.props.deviceGroupConfirmation ? classes.CancelButton : this.props.firmwareUpdateConfirm ? classes.firmwareUpdateCancelBtn : classes.RegularButton}
          onClick={this.props.cancel}
        >
          {this.props.cancelButtonLabel || 'Cancel'}
        </button>

        <button
          id={this.props.id ? this.props.id : this.props.confirmlId ? this.props.confirmlId : 'ModalOKButton'}
          visibility='true'
          className={this.props.deviceGroupConfirmation ? classes.ConfirmButton : this.props.firmwareUpdateConfirm ? classes.firmwareupdateConfirmBtn : classes.RegularButton}
          onClick={this.props.confirm}
        >
          {this.props.confirmButtonLabel || 'OK'}
        </button>
      </div>
    );

    if (this.props.loading) {
      form = <Spinner />;
    }

    let messageHtml;

    if (this.props.deviceGroupConfirmation || this.props.firmwareUpdateConfirm || this.props.confirmMsgStyling) {
      messageHtml = <h4 >{this.props.result} {!this.props.hideActionText && this.props.action}</h4>;
    } else {
      messageHtml = <h4 >{this.props.result} Are you sure you want to {this.props.action}?</h4>;
    }
    // console.log('headerStyle :::', this.props.headerStyle)

    return (
      <div className={classes.Confirm}>
        {!this.props.hideContent && <div id='confirmHeader' className={`${classes.HeaderRow} ${this.props.headerStyle}`}>
          {messageHtml}
        </div>}
        {this.props.subText && <div>{this.props.subText}</div>}
        {form}
      </div>
    );
  }
}

const mapStateToProps = () => ({});
const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(Confirm, axios));
